import React, { useContext } from "react";
import AdminsTable from "./AdminsTable";
import { Button, Space } from "antd";
import { context } from "../../context/context";

const Admins = () => {
    const {setIsAdminModalOpen} = useContext(context)
  return (
    <>
     
      <Space
        direction="vertical"
        style={{ width: "100%", justifyContent: "space-between" }}
        align="end"
      >
        <Button
          onClick={() => {
            setIsAdminModalOpen(true);
          }}
          type="primary"
        >
            اضافه کردن ادمین جدید
        </Button>
      </Space>
      <AdminsTable />{" "}
    </>
  );
};

export default Admins;
